import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {
  DelayedFileUploadCardComponent
} from "../../../../../../shared/components/ui/delayed-file-upload-card/delayed-file-upload-card.component";
import {
  EXCEL_EXTENSIONS
} from "../../../../../../core/components/modals/upload-excel-modal/configs/upload-excel-modal-config";
import {MatButton} from "@angular/material/button";
import {FilesService} from "../../../../../../core/services/files.service";
import {ImportProductPackagesDialogData, UploadProductPackagesExcelParams} from "./types/import-product-packages.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ImportProductPackagesService} from "./services/import-product-packages.service";
import {importProductPackagesModalName} from "./configs/import-product-packages-config";

@Component({
  selector: 'app-import-product-packages-modal',
  imports: [
    BaseModalComponent,
    DelayedFileUploadCardComponent,
    MatButton
  ],
  templateUrl: './import-product-packages-modal.component.html',
  styleUrl: './import-product-packages-modal.component.scss'
})
export class ImportProductPackagesModalComponent extends BaseModalComponent {
  private importProductPackagesDialogData = inject<ImportProductPackagesDialogData>(MAT_DIALOG_DATA);
  private filesService: FilesService = inject(FilesService);
  private importProductPackagesService: ImportProductPackagesService = inject(ImportProductPackagesService);

  public readonly excelExtensions = EXCEL_EXTENSIONS;
  public selectedFile: File | null = null;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(importProductPackagesModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(importProductPackagesModalName);
  }

  public filesSelectedForUpload(files: Array<File>): void {
    this.selectedFile = files[0];
  }

  public async handleUploadExcel(): Promise<void> {
    if (!this.selectedFile) {
      this.errorService.showErrorMessage('Загрузите файл!')
      return;
    }

    const formData = this.filesService.createFormData({
      file: this.selectedFile,
      fileType: 'file'
    });

    const uploadProductPackagesExcelParams: UploadProductPackagesExcelParams = {
      file: formData,
      technicalParametersId: this.importProductPackagesDialogData.parentId,
      path: 'product-packages/import-single',
      fileName: this.selectedFile?.name
    };

    this.loadingService.setIsLoadingState(true);
    await this.importProductPackagesService.importProductPackagesExcel(uploadProductPackagesExcelParams)
      .then(() => this.successImport())
      .catch(() => this.closeDialog('cancel'))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private successImport(): void {
    this.snackbarService.showMessage({
      message: 'Файл успешно загружен!',
      type: 'success'
    });
    this.closeDialog('success');
  }
}
